import { connect } from 'react-redux';
// Components
import GeneralProgrammingTable from '../components/screens/generalProgramming/GeneralProgrammingTable';
// Fixtures
import fixtures from '../fixtures/index';


let schedule;

const mapStateToProps = (state) => {
  const activeDay = state.dateSelector;
  switch (state.localeSelector) {
    case 'pt':
      schedule = fixtures.schedulePt.filter((s) => s.day === activeDay)[0].schedule;
      break;
    case 'es':
      schedule = fixtures.scheduleEs.filter((s) => s.day === activeDay)[0].schedule;
      break;
    default:
      schedule = fixtures.scheduleEn.filter((s) => s.day === activeDay)[0].schedule;
  }

  return {
    activeDay,
    schedule,
  };
};

const GeneralProgrammingContainer = connect(
  mapStateToProps
)(GeneralProgrammingTable);

export default GeneralProgrammingContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/GeneralProgrammingContainer.js
 **/